import "./style.css";

import Logo from "../../images/Logo.png";

export default function Header() {
  return (
    <div className="header-container">
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <div className="logo">
            <img src={Logo} alt="Logo" />
          </div>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul className="navbar-nav me-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link" href="#ServicesProvided">Serviços</a>
              </li>
              <span>|</span>
              <li className="nav-item">
                <a className="nav-link" href="#Feedback">Avaliações</a>
              </li>
              <span>|</span>
              <li className="nav-item">
                <a className="nav-link" href="#Contact">Onde estamos</a>
              </li>
            </ul>
            <div className='button'>
              <a href="https://wa.me/554284093699" target="_blank" rel="noreferrer">
                <button>Fale conosco</button>
              </a>
            </div>
          </div>
        </div>
      </nav>
    </div>
  );
};